import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _8c267298 = () => interopDefault(import('../pages/intro-to-529s/which-is-the-best-529-plan-available/index.vue' /* webpackChunkName: "" */))
const _f0809428 = () => interopDefault(import('../pages/529-plan-details/index.vue' /* webpackChunkName: "pages/529-plan-details/index" */))
const _2e834d50 = () => interopDefault(import('../pages/529-plan-investment-options/index.vue' /* webpackChunkName: "pages/529-plan-investment-options/index" */))
const _25c2081a = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _9ecc3360 = () => interopDefault(import('../pages/articles-professional/index.vue' /* webpackChunkName: "pages/articles-professional/index" */))
const _aaeb7b44 = () => interopDefault(import('../pages/college-financing-calculators/index.vue' /* webpackChunkName: "pages/college-financing-calculators/index" */))
const _155b3330 = () => interopDefault(import('../pages/college-planning/index.vue' /* webpackChunkName: "pages/college-planning/index" */))
const _9ad9e6fe = () => interopDefault(import('../pages/college-savings-101/index.vue' /* webpackChunkName: "pages/college-savings-101/index" */))
const _4dd0164e = () => interopDefault(import('../pages/colleges/index.vue' /* webpackChunkName: "pages/colleges/index" */))
const _580a2cca = () => interopDefault(import('../pages/compare-529-plans/index.vue' /* webpackChunkName: "pages/compare-529-plans/index" */))
const _4d9c1b4a = () => interopDefault(import('../pages/compare-plans/index.vue' /* webpackChunkName: "pages/compare-plans/index" */))
const _e6a8c7ec = () => interopDefault(import('../pages/eligible-institutions/index.vue' /* webpackChunkName: "pages/eligible-institutions/index" */))
const _6ecddfb8 = () => interopDefault(import('../pages/enroll-in-a-529-plan/index.vue' /* webpackChunkName: "pages/enroll-in-a-529-plan/index" */))
const _2f440951 = () => interopDefault(import('../pages/financial-aid/index.vue' /* webpackChunkName: "pages/financial-aid/index" */))
const _575ff262 = () => interopDefault(import('../pages/financial-aid-calculator-licenced/index.vue' /* webpackChunkName: "pages/financial-aid-calculator-licenced/index" */))
const _09ba876a = () => interopDefault(import('../pages/financial-aid-calculator-portals.vue' /* webpackChunkName: "pages/financial-aid-calculator-portals" */))
const _2bcddb5a = () => interopDefault(import('../pages/grandparents/index.vue' /* webpackChunkName: "pages/grandparents/index" */))
const _328f2d49 = () => interopDefault(import('../pages/interstitial/index.vue' /* webpackChunkName: "pages/interstitial/index" */))
const _28b6621c = () => interopDefault(import('../pages/kpmg/index.vue' /* webpackChunkName: "pages/kpmg/index" */))
const _38cf8bf7 = () => interopDefault(import('../pages/non-us-user-merrill/index.vue' /* webpackChunkName: "pages/non-us-user-merrill/index" */))
const _e5606866 = () => interopDefault(import('../pages/pro-dashboard/index.vue' /* webpackChunkName: "pages/pro-dashboard/index" */))
const _677fdc12 = () => interopDefault(import('../pages/prudential/index.vue' /* webpackChunkName: "pages/prudential/index" */))
const _3debf7e4 = () => interopDefault(import('../pages/questions-answers/index.vue' /* webpackChunkName: "pages/questions-answers/index" */))
const _cf86b784 = () => interopDefault(import('../pages/resources/index.vue' /* webpackChunkName: "pages/resources/index" */))
const _3f567d46 = () => interopDefault(import('../pages/savings-center/index.vue' /* webpackChunkName: "pages/savings-center/index" */))
const _533c6a45 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _37da4dba = () => interopDefault(import('../pages/subscribe/index.vue' /* webpackChunkName: "pages/subscribe/index" */))
const _0419e0a8 = () => interopDefault(import('../pages/test.vue' /* webpackChunkName: "pages/test" */))
const _5726b058 = () => interopDefault(import('../pages/tools-calculators/index.vue' /* webpackChunkName: "pages/tools-calculators/index" */))
const _17c46dad = () => interopDefault(import('../pages/tutorial101/index.vue' /* webpackChunkName: "pages/tutorial101/index" */))
const _077e717a = () => interopDefault(import('../pages/529-plan-details/sfc-plan-table-wrapper.vue' /* webpackChunkName: "pages/529-plan-details/sfc-plan-table-wrapper" */))
const _020c7c6c = () => interopDefault(import('../pages/529-plans/portfolio-snapshots.vue' /* webpackChunkName: "pages/529-plans/portfolio-snapshots" */))
const _7e68f91f = () => interopDefault(import('../pages/articles-professional/all.vue' /* webpackChunkName: "pages/articles-professional/all" */))
const _2c39f52e = () => interopDefault(import('../pages/articles/all.vue' /* webpackChunkName: "pages/articles/all" */))
const _66ee4244 = () => interopDefault(import('../pages/calculators/college-savings-calculator.vue' /* webpackChunkName: "pages/calculators/college-savings-calculator" */))
const _5ee41ae6 = () => interopDefault(import('../pages/calculators/cost-of-deferment-calculator.vue' /* webpackChunkName: "pages/calculators/cost-of-deferment-calculator" */))
const _732e7592 = () => interopDefault(import('../pages/calculators/income-based-repayment-calculator.vue' /* webpackChunkName: "pages/calculators/income-based-repayment-calculator" */))
const _9319037c = () => interopDefault(import('../pages/calculators/income-contingent-repayment-calculator.vue' /* webpackChunkName: "pages/calculators/income-contingent-repayment-calculator" */))
const _efdcfc12 = () => interopDefault(import('../pages/calculators/loan-calculator.vue' /* webpackChunkName: "pages/calculators/loan-calculator" */))
const _35081961 = () => interopDefault(import('../pages/calculators/loan-comparison-calculator.vue' /* webpackChunkName: "pages/calculators/loan-comparison-calculator" */))
const _52d14027 = () => interopDefault(import('../pages/calculators/loan-prepayment-calculator.vue' /* webpackChunkName: "pages/calculators/loan-prepayment-calculator" */))
const _79288eb6 = () => interopDefault(import('../pages/calculators/pay-as-you-earn-repayment-calculator.vue' /* webpackChunkName: "pages/calculators/pay-as-you-earn-repayment-calculator" */))
const _6c382115 = () => interopDefault(import('../pages/calculators/prudential-white-label.vue' /* webpackChunkName: "pages/calculators/prudential-white-label" */))
const _e355aa34 = () => interopDefault(import('../pages/calculators/revised-pay-as-you-earn-repayment-calculator.vue' /* webpackChunkName: "pages/calculators/revised-pay-as-you-earn-repayment-calculator" */))
const _e295bcb2 = () => interopDefault(import('../pages/calculators/scholarship-tax-calculator.vue' /* webpackChunkName: "pages/calculators/scholarship-tax-calculator" */))
const _29421b96 = () => interopDefault(import('../pages/calculators/student-loan-payoff-calculator.vue' /* webpackChunkName: "pages/calculators/student-loan-payoff-calculator" */))
const _062629eb = () => interopDefault(import('../pages/calculators/student-loan-refinance-calculator.vue' /* webpackChunkName: "pages/calculators/student-loan-refinance-calculator" */))
const _28d66ee6 = () => interopDefault(import('../pages/calculators/trust-fund-calculator.vue' /* webpackChunkName: "pages/calculators/trust-fund-calculator" */))
const _5ceb9687 = () => interopDefault(import('../pages/error/404.vue' /* webpackChunkName: "pages/error/404" */))
const _61d494f4 = () => interopDefault(import('../pages/financial-aid-calculator-licenced/results.vue' /* webpackChunkName: "pages/financial-aid-calculator-licenced/results" */))
const _50b09976 = () => interopDefault(import('../pages/kpmg/login/index.vue' /* webpackChunkName: "pages/kpmg/login/index" */))
const _52c8089e = () => interopDefault(import('../pages/prudential/college-cost-calculator.vue' /* webpackChunkName: "pages/prudential/college-cost-calculator" */))
const _eba80ef2 = () => interopDefault(import('../pages/prudential/compare-savings-options.vue' /* webpackChunkName: "pages/prudential/compare-savings-options" */))
const _18dd8c32 = () => interopDefault(import('../pages/prudential/cost-calculator.vue' /* webpackChunkName: "pages/prudential/cost-calculator" */))
const _bcbd0bfa = () => interopDefault(import('../pages/prudential/price-of-procrastination.vue' /* webpackChunkName: "pages/prudential/price-of-procrastination" */))
const _6e626aea = () => interopDefault(import('../pages/prudential/state-tax-calculator.vue' /* webpackChunkName: "pages/prudential/state-tax-calculator" */))
const _3c4a1be4 = () => interopDefault(import('../pages/savings-center/account/index.vue' /* webpackChunkName: "pages/savings-center/account/index" */))
const _169a8587 = () => interopDefault(import('../pages/savings-center/auto-login.vue' /* webpackChunkName: "pages/savings-center/auto-login" */))
const _2629d1f5 = () => interopDefault(import('../pages/savings-center/auto-register.vue' /* webpackChunkName: "pages/savings-center/auto-register" */))
const _28ec5c0e = () => interopDefault(import('../pages/savings-center/forgot-password.vue' /* webpackChunkName: "pages/savings-center/forgot-password" */))
const _35dcc612 = () => interopDefault(import('../pages/savings-center/grow/index.vue' /* webpackChunkName: "pages/savings-center/grow/index" */))
const _7e4e138a = () => interopDefault(import('../pages/savings-center/learn/index.vue' /* webpackChunkName: "pages/savings-center/learn/index" */))
const _08fe205d = () => interopDefault(import('../pages/savings-center/login.vue' /* webpackChunkName: "pages/savings-center/login" */))
const _5d06d29d = () => interopDefault(import('../pages/savings-center/nps-feedback.vue' /* webpackChunkName: "pages/savings-center/nps-feedback" */))
const _4ad2ffef = () => interopDefault(import('../pages/savings-center/open-a-plan/index.vue' /* webpackChunkName: "pages/savings-center/open-a-plan/index" */))
const _543e86fc = () => interopDefault(import('../pages/savings-center/track/index.vue' /* webpackChunkName: "pages/savings-center/track/index" */))
const _282deed9 = () => interopDefault(import('../pages/savings-center/welcome/index.vue' /* webpackChunkName: "pages/savings-center/welcome/index" */))
const _255d3019 = () => interopDefault(import('../pages/tests/1.vue' /* webpackChunkName: "pages/tests/1" */))
const _256b479a = () => interopDefault(import('../pages/tests/2.vue' /* webpackChunkName: "pages/tests/2" */))
const _25795f1b = () => interopDefault(import('../pages/tests/3.vue' /* webpackChunkName: "pages/tests/3" */))
const _2587769c = () => interopDefault(import('../pages/tests/4.vue' /* webpackChunkName: "pages/tests/4" */))
const _25958e1d = () => interopDefault(import('../pages/tests/5.vue' /* webpackChunkName: "pages/tests/5" */))
const _9e868658 = () => interopDefault(import('../pages/tests/data_store.vue' /* webpackChunkName: "pages/tests/data_store" */))
const _2209a96a = () => interopDefault(import('../pages/tests/data_store_gv.vue' /* webpackChunkName: "pages/tests/data_store_gv" */))
const _7cfea85e = () => interopDefault(import('../pages/tests/graphql.vue' /* webpackChunkName: "pages/tests/graphql" */))
const _5cccb965 = () => interopDefault(import('../pages/tests/member/index.vue' /* webpackChunkName: "pages/tests/member/index" */))
const _64362238 = () => interopDefault(import('../pages/tutorial101/federal-tax-incentives-to-education.vue' /* webpackChunkName: "pages/tutorial101/federal-tax-incentives-to-education" */))
const _6aa4eec9 = () => interopDefault(import('../pages/tutorial101/putting-your-plan-together.vue' /* webpackChunkName: "pages/tutorial101/putting-your-plan-together" */))
const _216b5b7e = () => interopDefault(import('../pages/tutorial101/special-considerations-for-grandparents.vue' /* webpackChunkName: "pages/tutorial101/special-considerations-for-grandparents" */))
const _fb5829a4 = () => interopDefault(import('../pages/tutorial101/the-real-cost-of-higher-education.vue' /* webpackChunkName: "pages/tutorial101/the-real-cost-of-higher-education" */))
const _b29c6c8a = () => interopDefault(import('../pages/tutorial101/tough-choices.vue' /* webpackChunkName: "pages/tutorial101/tough-choices" */))
const _11888370 = () => interopDefault(import('../pages/tutorial101/your-goal.vue' /* webpackChunkName: "pages/tutorial101/your-goal" */))
const _28e61bf6 = () => interopDefault(import('../pages/savings-center/onboarding/error-status-bar.vue' /* webpackChunkName: "pages/savings-center/onboarding/error-status-bar" */))
const _b1f010f6 = () => interopDefault(import('../pages/savings-center/onboarding/loading-screen.vue' /* webpackChunkName: "pages/savings-center/onboarding/loading-screen" */))
const _0bd41ea0 = () => interopDefault(import('../pages/savings-center/onboarding/progress-status-bar.vue' /* webpackChunkName: "pages/savings-center/onboarding/progress-status-bar" */))
const _8f40f57c = () => interopDefault(import('../pages/savings-center/open-a-plan/compare.vue' /* webpackChunkName: "pages/savings-center/open-a-plan/compare" */))
const _2851b4a3 = () => interopDefault(import('../pages/tests/member/after_register.vue' /* webpackChunkName: "pages/tests/member/after_register" */))
const _0ee6c1b6 = () => interopDefault(import('../pages/tests/member/before_register.vue' /* webpackChunkName: "pages/tests/member/before_register" */))
const _26745c7c = () => interopDefault(import('../pages/tests/member/login.vue' /* webpackChunkName: "pages/tests/member/login" */))
const _8530ca40 = () => interopDefault(import('../pages/tests/member/register.vue' /* webpackChunkName: "pages/tests/member/register" */))
const _3f5f5dae = () => interopDefault(import('../pages/tests/redesign-v1/inputs.vue' /* webpackChunkName: "pages/tests/redesign-v1/inputs" */))
const _55740cd5 = () => interopDefault(import('../pages/savings-center/onboarding/questions/children-savings.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/children-savings" */))
const _75bd26cc = () => interopDefault(import('../pages/savings-center/onboarding/questions/children-savings-total.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/children-savings-total" */))
const _3dd3329b = () => interopDefault(import('../pages/savings-center/onboarding/questions/email-capture.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/email-capture" */))
const _0974617e = () => interopDefault(import('../pages/savings-center/onboarding/questions/household-income.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/household-income" */))
const _6cb0903f = () => interopDefault(import('../pages/savings-center/onboarding/questions/more-help.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/more-help" */))
const _28190736 = () => interopDefault(import('../pages/savings-center/onboarding/questions/state-of-residence.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/state-of-residence" */))
const _2ca4106a = () => interopDefault(import('../pages/savings-center/onboarding/questions/tax-filing-status.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/tax-filing-status" */))
const _431fbffc = () => interopDefault(import('../pages/savings-center/onboarding/questions/user-type.vue' /* webpackChunkName: "pages/savings-center/onboarding/questions/user-type" */))
const _76c2d4ed = () => interopDefault(import('../pages/questions-answers/article/_slug.vue' /* webpackChunkName: "pages/questions-answers/article/_slug" */))
const _81bb561a = () => interopDefault(import('../pages/savings-center/learn/_slug.vue' /* webpackChunkName: "pages/savings-center/learn/_slug" */))
const _2b1245f0 = () => interopDefault(import('../pages/529-plans/_stateSlug/index.vue' /* webpackChunkName: "pages/529-plans/_stateSlug/index" */))
const _39665ad8 = () => interopDefault(import('../pages/calculators/_v3.vue' /* webpackChunkName: "pages/calculators/_v3" */))
const _25edb768 = () => interopDefault(import('../pages/college/_slug.vue' /* webpackChunkName: "pages/college/_slug" */))
const _02142ef6 = () => interopDefault(import('../pages/compare-529-plans/_slug/index.vue' /* webpackChunkName: "pages/compare-529-plans/_slug/index" */))
const _5b1b0e34 = () => interopDefault(import('../pages/529-plans/_stateSlug/_planSlug/index.vue' /* webpackChunkName: "pages/529-plans/_stateSlug/_planSlug/index" */))
const _51eda4ea = () => interopDefault(import('../pages/college/_stateSlug/_slug.vue' /* webpackChunkName: "pages/college/_stateSlug/_slug" */))
const _6fba9fb5 = () => interopDefault(import('../pages/529-plans/_stateSlug/_planSlug/investment-options/index.vue' /* webpackChunkName: "pages/529-plans/_stateSlug/_planSlug/investment-options/index" */))
const _9a2a3216 = () => interopDefault(import('../pages/529-plans/_stateSlug/_planSlug/investment-options/_portfolioSlug/_shareClassSlug.vue' /* webpackChunkName: "pages/529-plans/_stateSlug/_planSlug/investment-options/_portfolioSlug/_shareClassSlug" */))

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				let position = false
				if (to.matched.length < 2) {
					if (to.matched.some(r => r.components.default.options.keepScroll)) {
						position = false
					} else {
						position = { x: 0, y: 0 }
					}
				} else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
					position = { x: 0, y: 0 }
				}
				if (to.hash) {
					position = { selector: to.hash }
				}
				return position
			}
		}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/intro-to-529s/which-is-the-best-529-plan-available-spanish",
      component: _8c267298,
      name: "intro-to-529s-which-is-the-best-529-plan-available-spanish"
    }, {
      path: "/529-plan-details",
      component: _f0809428,
      name: "529-plan-details"
    }, {
      path: "/529-plan-investment-options",
      component: _2e834d50,
      name: "529-plan-investment-options"
    }, {
      path: "/articles",
      component: _25c2081a,
      name: "articles"
    }, {
      path: "/articles-professional",
      component: _9ecc3360,
      name: "articles-professional"
    }, {
      path: "/college-financing-calculators",
      component: _aaeb7b44,
      name: "college-financing-calculators"
    }, {
      path: "/college-planning",
      component: _155b3330,
      name: "college-planning"
    }, {
      path: "/college-savings-101",
      component: _9ad9e6fe,
      name: "college-savings-101"
    }, {
      path: "/colleges",
      component: _4dd0164e,
      name: "colleges"
    }, {
      path: "/compare-529-plans",
      component: _580a2cca,
      name: "compare-529-plans"
    }, {
      path: "/compare-plans",
      component: _4d9c1b4a,
      name: "compare-plans"
    }, {
      path: "/eligible-institutions",
      component: _e6a8c7ec,
      name: "eligible-institutions"
    }, {
      path: "/enroll-in-a-529-plan",
      component: _6ecddfb8,
      name: "enroll-in-a-529-plan"
    }, {
      path: "/financial-aid",
      component: _2f440951,
      name: "financial-aid"
    }, {
      path: "/financial-aid-calculator-licenced",
      component: _575ff262,
      name: "financial-aid-calculator-licenced"
    }, {
      path: "/financial-aid-calculator-portals",
      component: _09ba876a,
      name: "financial-aid-calculator-portals"
    }, {
      path: "/grandparents",
      component: _2bcddb5a,
      name: "grandparents"
    }, {
      path: "/interstitial",
      component: _328f2d49,
      name: "interstitial"
    }, {
      path: "/kpmg",
      component: _28b6621c,
      name: "kpmg"
    }, {
      path: "/non-us-user-merrill",
      component: _38cf8bf7,
      name: "non-us-user-merrill"
    }, {
      path: "/pro-dashboard",
      component: _e5606866,
      name: "pro-dashboard"
    }, {
      path: "/prudential",
      component: _677fdc12,
      name: "prudential"
    }, {
      path: "/questions-answers",
      component: _3debf7e4,
      name: "questions-answers"
    }, {
      path: "/resources",
      component: _cf86b784,
      name: "resources"
    }, {
      path: "/savings-center",
      component: _3f567d46,
      name: "savings-center"
    }, {
      path: "/search",
      component: _533c6a45,
      name: "search"
    }, {
      path: "/subscribe",
      component: _37da4dba,
      name: "subscribe"
    }, {
      path: "/test",
      component: _0419e0a8,
      name: "test"
    }, {
      path: "/tools-calculators",
      component: _5726b058,
      name: "tools-calculators"
    }, {
      path: "/tutorial101",
      component: _17c46dad,
      name: "tutorial101"
    }, {
      path: "/529-plan-details/sfc-plan-table-wrapper",
      component: _077e717a,
      name: "529-plan-details-sfc-plan-table-wrapper"
    }, {
      path: "/529-plans/portfolio-snapshots",
      component: _020c7c6c,
      name: "529-plans-portfolio-snapshots"
    }, {
      path: "/articles-professional/all",
      component: _7e68f91f,
      name: "articles-professional-all"
    }, {
      path: "/articles/all",
      component: _2c39f52e,
      name: "articles-all"
    }, {
      path: "/calculators/college-savings-calculator",
      component: _66ee4244,
      name: "calculators-college-savings-calculator"
    }, {
      path: "/calculators/cost-of-deferment-calculator",
      component: _5ee41ae6,
      name: "calculators-cost-of-deferment-calculator"
    }, {
      path: "/calculators/income-based-repayment-calculator",
      component: _732e7592,
      name: "calculators-income-based-repayment-calculator"
    }, {
      path: "/calculators/income-contingent-repayment-calculator",
      component: _9319037c,
      name: "calculators-income-contingent-repayment-calculator"
    }, {
      path: "/calculators/loan-calculator",
      component: _efdcfc12,
      name: "calculators-loan-calculator"
    }, {
      path: "/calculators/loan-comparison-calculator",
      component: _35081961,
      name: "calculators-loan-comparison-calculator"
    }, {
      path: "/calculators/loan-prepayment-calculator",
      component: _52d14027,
      name: "calculators-loan-prepayment-calculator"
    }, {
      path: "/calculators/pay-as-you-earn-repayment-calculator",
      component: _79288eb6,
      name: "calculators-pay-as-you-earn-repayment-calculator"
    }, {
      path: "/calculators/prudential-white-label",
      component: _6c382115,
      name: "calculators-prudential-white-label"
    }, {
      path: "/calculators/revised-pay-as-you-earn-repayment-calculator",
      component: _e355aa34,
      name: "calculators-revised-pay-as-you-earn-repayment-calculator"
    }, {
      path: "/calculators/scholarship-tax-calculator",
      component: _e295bcb2,
      name: "calculators-scholarship-tax-calculator"
    }, {
      path: "/calculators/student-loan-payoff-calculator",
      component: _29421b96,
      name: "calculators-student-loan-payoff-calculator"
    }, {
      path: "/calculators/student-loan-refinance-calculator",
      component: _062629eb,
      name: "calculators-student-loan-refinance-calculator"
    }, {
      path: "/calculators/trust-fund-calculator",
      component: _28d66ee6,
      name: "calculators-trust-fund-calculator"
    }, {
      path: "/error/404",
      component: _5ceb9687,
      name: "error-404"
    }, {
      path: "/financial-aid-calculator-licenced/results",
      component: _61d494f4,
      name: "financial-aid-calculator-licenced-results"
    }, {
      path: "/intro-to-529s/which-is-the-best-529-plan-available",
      component: _8c267298,
      name: "intro-to-529s-which-is-the-best-529-plan-available"
    }, {
      path: "/kpmg/login",
      component: _50b09976,
      name: "kpmg-login"
    }, {
      path: "/prudential/college-cost-calculator",
      component: _52c8089e,
      name: "prudential-college-cost-calculator"
    }, {
      path: "/prudential/compare-savings-options",
      component: _eba80ef2,
      name: "prudential-compare-savings-options"
    }, {
      path: "/prudential/cost-calculator",
      component: _18dd8c32,
      name: "prudential-cost-calculator"
    }, {
      path: "/prudential/price-of-procrastination",
      component: _bcbd0bfa,
      name: "prudential-price-of-procrastination"
    }, {
      path: "/prudential/state-tax-calculator",
      component: _6e626aea,
      name: "prudential-state-tax-calculator"
    }, {
      path: "/savings-center/account",
      component: _3c4a1be4,
      name: "savings-center-account"
    }, {
      path: "/savings-center/auto-login",
      component: _169a8587,
      name: "savings-center-auto-login"
    }, {
      path: "/savings-center/auto-register",
      component: _2629d1f5,
      name: "savings-center-auto-register"
    }, {
      path: "/savings-center/forgot-password",
      component: _28ec5c0e,
      name: "savings-center-forgot-password"
    }, {
      path: "/savings-center/grow",
      component: _35dcc612,
      name: "savings-center-grow"
    }, {
      path: "/savings-center/learn",
      component: _7e4e138a,
      name: "savings-center-learn"
    }, {
      path: "/savings-center/login",
      component: _08fe205d,
      name: "savings-center-login"
    }, {
      path: "/savings-center/nps-feedback",
      component: _5d06d29d,
      name: "savings-center-nps-feedback"
    }, {
      path: "/savings-center/open-a-plan",
      component: _4ad2ffef,
      name: "savings-center-open-a-plan"
    }, {
      path: "/savings-center/track",
      component: _543e86fc,
      name: "savings-center-track"
    }, {
      path: "/savings-center/welcome",
      component: _282deed9,
      name: "savings-center-welcome"
    }, {
      path: "/tests/1",
      component: _255d3019,
      name: "tests-1"
    }, {
      path: "/tests/2",
      component: _256b479a,
      name: "tests-2"
    }, {
      path: "/tests/3",
      component: _25795f1b,
      name: "tests-3"
    }, {
      path: "/tests/4",
      component: _2587769c,
      name: "tests-4"
    }, {
      path: "/tests/5",
      component: _25958e1d,
      name: "tests-5"
    }, {
      path: "/tests/data_store",
      component: _9e868658,
      name: "tests-data_store"
    }, {
      path: "/tests/data_store_gv",
      component: _2209a96a,
      name: "tests-data_store_gv"
    }, {
      path: "/tests/graphql",
      component: _7cfea85e,
      name: "tests-graphql"
    }, {
      path: "/tests/member",
      component: _5cccb965,
      name: "tests-member"
    }, {
      path: "/tutorial101/federal-tax-incentives-to-education",
      component: _64362238,
      name: "tutorial101-federal-tax-incentives-to-education"
    }, {
      path: "/tutorial101/putting-your-plan-together",
      component: _6aa4eec9,
      name: "tutorial101-putting-your-plan-together"
    }, {
      path: "/tutorial101/special-considerations-for-grandparents",
      component: _216b5b7e,
      name: "tutorial101-special-considerations-for-grandparents"
    }, {
      path: "/tutorial101/the-real-cost-of-higher-education",
      component: _fb5829a4,
      name: "tutorial101-the-real-cost-of-higher-education"
    }, {
      path: "/tutorial101/tough-choices",
      component: _b29c6c8a,
      name: "tutorial101-tough-choices"
    }, {
      path: "/tutorial101/your-goal",
      component: _11888370,
      name: "tutorial101-your-goal"
    }, {
      path: "/savings-center/onboarding/error-status-bar",
      component: _28e61bf6,
      name: "savings-center-onboarding-error-status-bar"
    }, {
      path: "/savings-center/onboarding/loading-screen",
      component: _b1f010f6,
      name: "savings-center-onboarding-loading-screen"
    }, {
      path: "/savings-center/onboarding/progress-status-bar",
      component: _0bd41ea0,
      name: "savings-center-onboarding-progress-status-bar"
    }, {
      path: "/savings-center/open-a-plan/compare",
      component: _8f40f57c,
      name: "savings-center-open-a-plan-compare"
    }, {
      path: "/tests/member/after_register",
      component: _2851b4a3,
      name: "tests-member-after_register"
    }, {
      path: "/tests/member/before_register",
      component: _0ee6c1b6,
      name: "tests-member-before_register"
    }, {
      path: "/tests/member/login",
      component: _26745c7c,
      name: "tests-member-login"
    }, {
      path: "/tests/member/register",
      component: _8530ca40,
      name: "tests-member-register"
    }, {
      path: "/tests/redesign-v1/inputs",
      component: _3f5f5dae,
      name: "tests-redesign-v1-inputs"
    }, {
      path: "/savings-center/onboarding/questions/children-savings",
      component: _55740cd5,
      name: "savings-center-onboarding-questions-children-savings"
    }, {
      path: "/savings-center/onboarding/questions/children-savings-total",
      component: _75bd26cc,
      name: "savings-center-onboarding-questions-children-savings-total"
    }, {
      path: "/savings-center/onboarding/questions/email-capture",
      component: _3dd3329b,
      name: "savings-center-onboarding-questions-email-capture"
    }, {
      path: "/savings-center/onboarding/questions/household-income",
      component: _0974617e,
      name: "savings-center-onboarding-questions-household-income"
    }, {
      path: "/savings-center/onboarding/questions/more-help",
      component: _6cb0903f,
      name: "savings-center-onboarding-questions-more-help"
    }, {
      path: "/savings-center/onboarding/questions/state-of-residence",
      component: _28190736,
      name: "savings-center-onboarding-questions-state-of-residence"
    }, {
      path: "/savings-center/onboarding/questions/tax-filing-status",
      component: _2ca4106a,
      name: "savings-center-onboarding-questions-tax-filing-status"
    }, {
      path: "/savings-center/onboarding/questions/user-type",
      component: _431fbffc,
      name: "savings-center-onboarding-questions-user-type"
    }, {
      path: "/questions-answers/article/:slug?",
      component: _76c2d4ed,
      name: "questions-answers-article-slug"
    }, {
      path: "/savings-center/learn/:slug",
      component: _81bb561a,
      name: "savings-center-learn-slug"
    }, {
      path: "/529-plans/:stateSlug?",
      component: _2b1245f0,
      name: "529-plans-stateSlug"
    }, {
      path: "/calculators/:v3?",
      component: _39665ad8,
      name: "calculators-v3"
    }, {
      path: "/college/:slug",
      component: _25edb768,
      name: "college-slug"
    }, {
      path: "/compare-529-plans/:slug",
      component: _02142ef6,
      name: "compare-529-plans-slug"
    }, {
      path: "/529-plans/:stateSlug?/:planSlug",
      component: _5b1b0e34,
      name: "529-plans-stateSlug-planSlug"
    }, {
      path: "/college/:stateSlug/:slug?",
      component: _51eda4ea,
      name: "college-stateSlug-slug"
    }, {
      path: "/529-plans/:stateSlug?/:planSlug/investment-options",
      component: _6fba9fb5,
      name: "529-plans-stateSlug-planSlug-investment-options"
    }, {
      path: "/529-plans/:stateSlug?/:planSlug/investment-options/:portfolioSlug?/:shareClassSlug",
      component: _9a2a3216,
      name: "529-plans-stateSlug-planSlug-investment-options-portfolioSlug-shareClassSlug"
    }],

    fallback: false
  })
}
